module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'media',
		'image',
		'image'
	],

	config: {
		additionalDataInclusionTemplate: './baseFormMediaImageAdditionalData'
	}
}